export const DEVELOPER_USER_ACCOUNTS = [
  'cupids@aphrodite.global',
  'k34liang@uwaterloo.ca',
  'c585li@uwaterloo.ca',
  'huiwenyang.yang@mail.utoronto.ca',
];
